import { render, staticRenderFns } from "./MemberCardInfo.vue?vue&type=template&id=2299e4c3&scoped=true"
import script from "./MemberCardInfo.vue?vue&type=script&lang=js"
export * from "./MemberCardInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2299e4c3",
  null
  
)

export default component.exports